import { getProjectCards } from "../../api/ProjectLoader";
import { useEffect, useState } from "react";
import { useAuthInfo } from "@propelauth/react";
import ScrollTable from "../ui/ScrollableTable";
import { moneyFormatter } from "../../lib/formatters";
import { Project } from "../../models/project";

const GeneralProjectsInfo = () => {

    const [response, setResponse] = useState<Project[]>([]);
    const { accessToken } = useAuthInfo();

    useEffect(() => {
        if (accessToken) {
            getProjectCards(accessToken).then((data) => setResponse(data));
        }
    }, []);

    const getNestedValue = (obj: any, path: string) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    const buildRows = (
        label: string,
        property: string,
        key: keyof Project,
        type: "number" | "string" | "money"
    ) => {
        const result = response.reduce((acc: any, item: any) => {
            acc[item[property]] = getNestedValue(item, key); 
            return acc;
        }, {} as Record<string, any>);

        return {
            property: label,
            type: type,
            ...result,
        };
    };
    console.log(response)

    const data: any = [
        buildRows("number", "name", "number", "number"),
        buildRows("rom", "name", "ROM", "money"),
        buildRows("sector", "name", "sector", "string"),
        buildRows("sub sector", "name", "sub_sector", "string"),
        buildRows("gsf", "name", "gsf", "number"),
        buildRows("address", "name", "address.address" as 'address', "number"),
        buildRows("expected duration", "name", "expected_duration", "number"),
        buildRows(
            "expected start date",
            "name",
            "expected_start_date",
            "string"
        ),
    ];

    const generateColumns = (data: any) => {
        const firstColumn = {
            header: "",
            accessorKey: "property",
            // cell: (row: any) => row.original.property,
            cell: (row: any) => styledProperty(row.original.property),
            toggleSorting: () => {},
            getIsSorted: () => undefined,
        };

        const otherColumns = data.map((item: any) => ({
            header: styledProperty(item.name),
            accessorKey: item.name,
            // cell: (row: any) => row.original[item.name],
            cell: (row: any) => styledCell(row.original.type,row.original[item.name]),
        }));

        return [firstColumn, ...otherColumns];
    };
    
    const styledCell = (type:string, item:any) => {
        if (type==='money') {
            return (
                <div className="text-sm">{moneyFormatter.format(item)}</div>
            )
        } else {
            return (
                <div className="text-sm">{item}</div>
            )
        }
    }

    const styledProperty = ( item:any) => {
        return <div className="text-sm font-bold text-black">
            {item}
        </div>
    }

    const columns = generateColumns(response);

    return (
        <div>
            <ScrollTable columns={columns} data={data}/>
        </div>
    );
};

export default GeneralProjectsInfo;
